export default __webpack_public_path__ + "static/media/upload.3edfd499.svg";